export default {"src":"/_next/static/media/white-check.b58a0631.svg","height":21,"width":21};